import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import { DEFAULT_ADDITIONAL_SETTINGS } from '../../settings_sidebar/chart/ChartSettings.jsx';
import DatasourceSettings from '../../settings_sidebar/datasource/DatasourceSettings.jsx';

function DonutWithTargetDatasetWidgetSettings({ widgetId }) {

    return (
        <>
            <DatasourceSettings
                widgetId={widgetId}
                datasource_props={{
                    setting_fields: ["colId", "target_colId", "name_item", "value", "target", "number_unit", "number_precision", "main_value_ds"]
                }}
            />
            <hr />
            <ChartDatasetSettings
                widgetId={widgetId}
                chart_settings_props={{
                    additional_settings: [...DEFAULT_ADDITIONAL_SETTINGS, "number_format", "show_total_value"],
                    show_total_value_tooltip: true    
                }}
                DatasetSettingsComponent={null}
            />
        </>
    )
}

export default DonutWithTargetDatasetWidgetSettings;
